import { useHistory } from 'react-router-dom';

const useRoute = () => {
  const history = useHistory();

  const handlePage = row => {
    history.push({
      pathname: '/definicion/departamento',
      state: {
        department: row.id,
        isComingFrom: '/definicion/seleccion/departamento',
      },
    });
  };

  return { handlePage };
};

export default useRoute;
